/**
 * 工具类
 * */

// 数字三位加逗号方法
function toThousands(num) {
  if(num) {
    return parseFloat(num).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  } else {
    return '0.00'
  }
}

module.exports = {
  toThousands,
}
